module.exports = __webpack_public_path__ + "static/media/tribe.d8f3c9f4.webp";